<template>
  <button class="chip">{{ label }}<IconCircleCrossFilled aria-hidden="true" /></button>
</template>

<script>
import IconCircleCrossFilled from '@/components/icons/IconCircleCrossFilled.vue'

export default {
  components: { IconCircleCrossFilled },
  props: {
    label: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss">
.chip {
  @include small-text;
  display: flex;
  background-color: $color-yellow-primary;
  border-radius: 16px;
  cursor: pointer;
  font-weight: $font-weight-medium;
  gap: 4px;
  padding: 4px 8px;
  white-space: nowrap;

  &:hover,
  &:focus {
    background-color: $color-yellow-dark;
  }
}
</style>
